import "../index.css";

function About({ isActive }) {
  return (
    <article
      className={isActive ? "about active" : "about"}
      data-page="about"
    >
      <header>
        <h2 className="h2 article-title">About Me</h2>
      </header>

      <section className="about-text">
        <p>I’m <b>Pravesh Goyal</b>, a backend engineer specializing in building scalable, cloud-native systems using Go.</p>

        <p>I’ve designed and implemented distributed microservices and high-performance REST/gRPC APIs, with a strong focus on clean architecture, reliability, and scalability. My experience spans PostgreSQL, MongoDB, and AWS, where I’ve built systems that handle production workloads with high availability.</p>

        <p>At {" "}<a href="https://www.mobileum.com/" target="_blank" rel="noreferrer">Mobileum</a>, I lead core backend development—owning API design, data modeling, and system reliability—ensuring services remain performant and resilient at scale.</p>

        <p>Previously, as a founding backend engineer at {" "}<a href="https://tykeinvest.com/" target="_blank" rel="noreferrer">TykeInvest</a>, I helped design and scale systems powering investment workflows for 30,000+ active users.</p>

        <p>I’m particularly interested in backend performance, distributed systems, and building infrastructure that scales efficiently under real-world load.</p>
      </section>

      {/* SKILLS */}
      <section className="clients">
        <h3 className="h3 clients-title">Skills</h3>

        <ul className="clients-list has-scrollbar">
          <li className="clients-item">
            <img
              alt="go"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original-wordmark.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="nodejs"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="mongodb"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original-wordmark.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="postgresql"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original-wordmark.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="redis"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original-wordmark.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="kafka"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original.svg"
              height="100"
              style={{ filter: "invert(1)" }}
            />
          </li>

          <li className="clients-item">
            <img
              alt="aws"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="docker"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="javascript"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
              height="100"
            />
          </li>

          <li className="clients-item">
            <img
              alt="git"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original-wordmark.svg"
              height="100"
            />
          </li>
        </ul>
      </section>
    </article>
  );
}

export default About;